import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const Rupeezy: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles, switchPage }) => {
  const { reDirectPage, updatePartialConfigs, changeApiKey, validateClientIdAndRedirect, isMobile } =
    brokerSpecificHandles;
  const {
    clientId,
    isLoading,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    selectedBrokerConfig,
  } = userConfigs;
  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated ? reDirectPage({}, false) : validateClientIdAndRedirect();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client ID"
        id={`${broker}-client-id`}
        value={clientId ?? ''}
        isDisabled={isClientValidated}
        placeholder="Enter Client ID"
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {!isClientValidated && clientId && (
        <button type="button" onClick={changeApiKey}>
          <i className="fa-regular fa-gear fa-spin" />
          Change API details?
        </button>
      )}

      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          placeholder="Enter API Key"
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowSecretKey && (
        <UserInput
          labelValue="API Secret"
          id={`${broker}-secret-key`}
          value={secretKey}
          placeholder="Enter API Secret"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {(shouldShowSecretKey || shouldShowApiKey) && (
        <button type="button" onClick={() => switchPage()}>
          <i className="fa-regular fa-gear fa-spin" />
          How to generate API details ?
        </button>
      )}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default Rupeezy;
